if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      document.querySelector('.AddToCartTextAdding').classList.remove('hidden');
      document.querySelector('.AddToCartText').classList.add('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
       	  document.querySelector('.AddToCartText').classList.remove('hidden');
          document.querySelector('.AddToCartTextAdding').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        document.querySelector('.AddToCartText').classList.remove('hidden');
        document.querySelector('.AddToCartTextAdding').classList.add('hidden');
      }
    }
  });
}

/* Manor House fix (Oct 2026): the theme's "View Cart" swap hid the Add to Cart button
   for good, so a shopper who emptied the cart (or wanted a second item) could not add again.
   Keep Add to Cart visible next to View Cart, and reset both if the page comes back from the
   browser's back/forward cache. */
(function () {
  function submitButtons() {
    return document.querySelectorAll('.product__info-container .product-form__buttons .product-form__submit');
  }
  // Any time the theme hides the Add to Cart button, show it again.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.target.classList && m.target.classList.contains('product-form__submit') && m.target.classList.contains('hide')) {
        m.target.classList.remove('hide');
      }
    });
  });
  function watch() {
    submitButtons().forEach(function (btn) {
      observer.observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      submitButtons().forEach(function (btn) { btn.classList.remove('hide'); });
      document.querySelectorAll('.view-cart').forEach(function (a) { a.classList.add('hide'); });
    }
  });
})();
